export default "__VITE_PUBLIC_ASSET__c315f030__"